import validate from 'jquery-validation';
validate;

function initialize() {
    $('.search-form').validate({
        onFocusOut: true,
        focusInvalid: false,
        errorClass: 'input-error',
        errorElement: 'span',
        errorLabelContainer: '.search-form .errors',
        rules: {
            search: 'required',
        },
        messages: {
            search: 'Campo obrigatório',
        },
        invalidHandler: function () {},
        submitHandler: function (form, evt) {
            evt.stopPropagation();
            evt.preventDefault();

            window.location = $(form).data('url') + $(form).find('input').val();
        },
    });
}

initialize();
